import React, { useState, useEffect } from 'react';
import { HomePage } from './pages/HomePage';
import { CafePage } from './pages/CafePage';
import { GamingPage } from './pages/GamingPage';
import { AdminPage } from './pages/AdminPage';
import { ReservationPage } from './pages/ReservationPage';
import { Navigation } from './components/Navigation';
import { PageView } from './types';

export default function App() {
  const [currentPage, setCurrentPage] = useState<PageView>('HOME');

  // Funkce pro scrollování nahoru při změně stránky
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const renderPage = () => {
    switch (currentPage) {
      case 'HOME':
        return <HomePage onNavigate={setCurrentPage} />;
      case 'CAFE':
        return <CafePage onNavigate={setCurrentPage} />;
      case 'GAMING':
        return <GamingPage onNavigate={setCurrentPage} />;
      case 'ADMIN':
        return <AdminPage onBack={() => setCurrentPage('HOME')} />;
      case 'MEMBERSHIP':
        return <GamingPage initialView="membership" onNavigate={setCurrentPage} />;
      case 'RESERVATION':
        return <ReservationPage />;
      case 'EVENTS':
        return <GamingPage initialView="events" onNavigate={setCurrentPage} />;
      case 'SHOP':
         // Placeholder pro shop, zatím Gaming Library
         return <GamingPage initialView="library" onNavigate={setCurrentPage} />;
      default:
        return <HomePage onNavigate={setCurrentPage} />;
    }
  };

  if (currentPage === 'ADMIN') {
      return <AdminPage onBack={() => setCurrentPage('HOME')} />;
  }

  return (
    <div className="min-h-screen bg-guild-bg text-guild-dark font-sans flex flex-col">
      {/* Globální navigace */}
      <Navigation activePage={currentPage} onNavigate={setCurrentPage} />
      
      {/* Hlavní obsah */}
      <main className="flex-grow">
        {renderPage()}
      </main>

      {/* Admin Trigger (Secret footer button style) */}
      <div className="fixed bottom-2 right-2 opacity-0 hover:opacity-100 transition-opacity z-50">
          <button onClick={() => setCurrentPage('ADMIN')} className="bg-black text-xs p-1 text-white rounded">Admin</button>
      </div>
    </div>
  );
}